import React from 'react';
import { makeStyles, Typography, Box } from '@material-ui/core';

import militaryTech from '../../assets/imgs/military_tech.svg';

const useStyles = makeStyles((theme) => ({
  card: {
    backgroundColor: theme.palette.neutrals.high.main,
    borderRadius: theme.spacing(1),
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(6),
    paddingBottom: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  header: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  position: {
    color: theme.palette.neutrals.low.main,
    fontSize: 14,
    fontWeight: 700,
    textTransform: 'lowercase',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    '-webkit-line-clamp': 1,
    '-webkit-box-orient': 'vertical',
  },
  score: {
    color: theme.palette.neutrals.low.main,
    fontSize: 20,
    fontWeight: 700,
    textTransform: 'lowercase',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    '-webkit-line-clamp': 1,
    '-webkit-box-orient': 'vertical',
  },
  name: {
    color: theme.palette.neutrals.low.main,
    fontSize: 14,
    fontWeight: 400,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    '-webkit-line-clamp': 1,
    '-webkit-box-orient': 'vertical',
  },
  colorActive: {
    color: theme.palette.primary.main,
    fontWeight: 700,
  },
  date: {
    color: theme.palette.neutrals.low.light,
    fontSize: 10,
    fontWeight: 400,
    paddingTop: theme.spacing(1.5),
  },
  icons: {
    color: theme.palette.neutrals.low.light,
  },
}));

function RankingCard(props) {
  const classes = useStyles();
  const isYou = props.ranking.userId === props.userId;
  return (
    <Box className={classes.card}>
      <Box className={classes.header}>
        {props.ranking.position <= 5 && (
          <img src={militaryTech} alt="campeao" style={{ width: 20 }} />
        )}
        <Typography
          className={`${classes.position} ${isYou && classes.colorActive}`}
          variant="subtitle2"
          color="primary"
          style={{ flexGrow: 1, paddingLeft: 8, alignSelf: 'flex-end' }}
        >
          {props.ranking.position}º
        </Typography>
      </Box>
      <Box pt={1.75}>
        <Typography
          className={`${classes.score} ${isYou && classes.colorActive}`}
          variant="subtitle2"
          color="primary"
          style={{ flexGrow: 1 }}
          component="p"
        >
          {parseInt(props.ranking.score)}
        </Typography>
      </Box>
      <Box>
        <Typography
          className={`${classes.name} ${isYou && classes.colorActive}`}
          variant="subtitle2"
          color="primary"
          style={{ flexGrow: 1 }}
          component="p"
        >
          {props.ranking.userName}
        </Typography>
      </Box>
      <Box>
        <Typography
          className={`${classes.name} ${isYou && classes.colorActive}`}
          variant="subtitle2"
          color="primary"
          style={{ flexGrow: 1 }}
          component="p"
        >
          {props.ranking.businessUnitLocals?.businessUnit?.name}
        </Typography>
      </Box>
    </Box>
  );
}

export { RankingCard };
